import { render, staticRenderFns } from "./EstudianteImportacionRegistro.vue?vue&type=template&id=6bb2b837&scoped=true"
import script from "./EstudianteImportacionRegistro.vue?vue&type=script&lang=js"
export * from "./EstudianteImportacionRegistro.vue?vue&type=script&lang=js"
import style0 from "./EstudianteImportacionRegistro.vue?vue&type=style&index=0&id=6bb2b837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2b837",
  null
  
)

export default component.exports